<template>
  <div v-show="isReptoReviewModalVisible">
    <transition name="slide">
      <div id="groupModal4" class="modal-mask"  @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">

                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                    <button class="text-uppercase btn btn-primary d-none mentee_title_btn">Apprentice</button>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                  </div>              
                </div>

                <div>
                  <div class="mt-1 mb-3 pl-3 pr-3">
                    <div class="row align-items-end">
                      <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                        <p class="text-uppercase mb-1 " 
                          :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
                          <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                        </p>
                        <div class="progress progress_pathway">
                          <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                        </div>
                      </div>        
                    </div>
                  </div>
                </div>

                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="text-uppercase font-weight-bold">{{ repCount }} Reps to Review</div>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="font-weight-bold text-uppercase" v-if="repTasks.length > 1"><a href="#" @click.prevent="toggleViewAll">{{ viewAll ? 'View Less' : 'View All' }}</a></div>
                  </div>              
                </div>

                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  >
                  {{ success_message }}
                </b-alert>


                <div>
                  <MenteeRepReview 
                    v-for="(repTask, index) in repTasks" :key="repTask.repId"
                    :repTask="repTask" 
                    :menteeFirstName="menteeFirstName"
                    :menteeShortName="menteeShortName"
                    :menteeId = "menteeId"
                    alignApproveDenyBtns="type2"
                    repReviewType="menteePage"
                    @reduceRepCount="reduceRepCount"
                    @removeRepTask="removeRepTask"          
                    v-if="index === 0 || viewAll"
                  ></MenteeRepReview>
                </div>      

                <div v-if="activeStep != ''">
                  <MenteeProgress
                    :menteeId="menteeId"
                    :stepId="activeStep"
                    :pathwayId="pathwayId"
                    :type="1"
                    @closeAddRep="closeAddRep"
                    ref="MenteeProgressComponent"
                    >
                  </MenteeProgress>
                </div>

              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import MenteeProgress from '@/components/manager/mentee_progress.vue';
import MenteeRepReview from '@/components/manager/mentee_rep_review.vue';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import MenteeAddRep from '@/components/manager/mentee_add_rep.vue';

export default {
  props: ['isReptoReviewModalVisible'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      repCount: '',
      repTasks: [],
      mentorsAssigned: [],
      viewAll: false,
      pathwayStepsData: [],
      menteeId: '',
      activeStep: '',
      pathwayId: '',
      showFutureSteps: false,
      success_message: '',
      dismissCountDown: 0,
      selectedRepTasks: [],
      selectedRepTasksIds: [],
    }
  },
  computed: {

  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    closeAddRep() {
      this.$parent.getAccountStatistics();
    },
    moveToStep(stepId) {
      if(this.showFutureSteps == true) {
        this.activeStep = stepId;
        this.$refs.MenteeProgressComponent.reloadStep(stepId);
      }
    },
    hide() {
      this.$emit('closeRepToReviewModal');
    },
    toggleViewAll() {
      this.viewAll = !this.viewAll;
    },
    reduceRepCount() {
      this.success_message = 'Rep reviewed successfully.';
      this.dismissCountDown = 5;
      this.repCount = this.repCount - 1;
      this.$parent.getAccountStatistics();
      this.$emit('reduceRepCount', {
        menteeId: this.menteeId,
        repCount: this.repCount,
      });
      
      if (this.repCount == 0) {
        // this.$emit('close-right-panel-modal');
        this.$emit('closeRepToReviewModal');
      }
    },
    removeRepTask(repTaskId) {
      const index = this.repTasks.findIndex(item => item.repId === repTaskId);
      if (index !== -1) {
        this.repTasks.splice(index, 1);
      }
    },
    openMenteeAddRepModal(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$refs.menteeAddRepModal.show();
    },
    closeMenteeAddRepModal() {
      this.$refs.menteeAddRepModal.hide();
    },
    closeMenteeEditRepModal() {
      this.$refs.menteeAddRepModal.hide();
    },
    getMenteeData(menteeId) {
      this.menteeId = menteeId;

      axios('/desktop/get-mentee-repitition-lists-all-tasklists', {
        method: 'GET',
        params: {
          mentee_id: this.menteeId,
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.repCount = data.rep_count;
        this.repTasks = data.rep_tasks;
        this.mentorsAssigned = data.mentors_assigned;
      })
      .catch(() => {});

      axios('/desktop/v2/pathway/get-mentee-pathway-progress', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.pathwayStepsData = data;
        this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
        this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
        this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
      })
      .catch(() => {});
    },
  },
  components: {
    MenteeProgress,
    MenteeRepReview,
    MenteePathwayProgress,
    MenteeAddRep,
  },
  created() {
    // if (this.isReptoReviewModalVisible) {
    //   this.getMenteeData();
    // }
  },
}
</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }

.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}
.progress_bar_100 {
  background-color: #00acee !important;
}
@media (min-width: 1200px) {
  .modal-lg {
    width: 650px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 550px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_reps_to_review.vue